export const APP_SET_LOADING = 'APP_SET_LOADING';
export const APP_SET_NOTIFICATION = 'APP_SET_NOTIFICATION';
export const APP_GET_REQUEST_COUNT_OF_UNREAD = 'APP_GET_REQUEST_COUNT_OF_UNREAD';
